import React from 'react';
import PositionAdd from "../../info/PositionAdd";
import {message} from "../../../../../utils/message";

/**
 * creat by xcc
 * @description 批量新增单个编辑
 */

export default class EditPosition extends PositionAdd {

    getPositionInfoById(id, callBack) {
        this.request({
            url: "/cm-sites-media-consumer/batch/getById",
            body: {
                id
            },
            callBack: (data) => {
                if (!data) {
                    message.warn("账号异常");
                    return;
                }
                if (data) {
                    callBack(data);
                }
            },
            errorCallBack: () => {

            },
            serverVerify: {
                serverErrorCallBack: () => {

                }
            }
        });
    }

    // 暂存
    save = (activiti, call) => {
        let that = this;
        const {isAssignment} = this.props;
       
        let url = '/cm-sites-media-consumer/batch/save';
        if(that.state.id) {
            url = "/cm-sites-media-consumer/batch/update";
        }

        if(isAssignment){
            this.state.formData.batchType = 2 
        }else{
            this.state.formData.batchType = 1
        }
        this.state.formData.activityExt = (this.auditRemarks && this.auditRemarks.getFormData()) || {};
        this.request({
            url,
            method: 'POST',
            body: this.state.formData,
            contentType: 'json',
            callBack: function (res, status, allData) {
                if (res) {
                    message.success('保存成功！');
                    that.onOkCall()
                } else {
                    message.warn('保存失败！');
                    call && call(false);
                }
            },
            errorCallBack: function (e) {
                call && call(false);
                window.loading.hide();
                message.warn('保存失败！');
            },
            serverVerify: {
                serverErrorCallBack: () => {
                    call && call(false);
                    window.loading.hide();
                },
                isShowErrorMsg: true
            }
        });
    };

}